import { CmsComponent } from '@spartacus/core';
import deepEqual from 'deep-equal';
import { decodeHTML } from 'entities';

export function deepEqualWithoutTime(cmp1: CmsComponent, cmp2: CmsComponent): boolean {
  return deepEqual(
    { ...cmp1, modifiedTime: undefined, modifiedtime: undefined },
    { ...cmp2, modifiedTime: undefined, modifiedtime: undefined }
  );
}

export function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export function waitForElmWithChildren(selector) {
  return new Promise((resolve) => {
    function check() {
      const el = document.querySelector(selector);
      if (el && el.children.length > 0) {
        resolve(el);
      } else {
        requestAnimationFrame(check);
      }
    }
    check();
  });
}

export function waitForShadowRoot(element: HTMLElement): Promise<ShadowRoot> {
  return new Promise((resolve) => {
    if (element.shadowRoot) {
      return resolve(element.shadowRoot);
    }

    const observer = new MutationObserver(() => {
      if (element.shadowRoot) {
        observer.disconnect();
        resolve(element.shadowRoot);
      }
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true
    });
  });
}

export function waitForShadowHost(): Promise<HTMLElement> {
  return new Promise((resolve) => {
    // Conversion sécurisée de NodeList en tableau
    const divs = Array.from(document.body.querySelectorAll('div'));
    const existing = divs.find((div) => div.shadowRoot);
    if (existing) return resolve(existing);

    const observer = new MutationObserver((mutations, obs) => {
      for (const mutation of mutations) {
        const addedNodes = Array.from(mutation.addedNodes);

        for (const node of addedNodes) {
          if (
            node instanceof HTMLElement &&
            node.tagName === 'DIV' &&
            node.shadowRoot
          ) {
            obs.disconnect();
            resolve(node);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export function decodeHTMLEntities(str) {
  if (str && typeof str === 'string') {
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
    str = decodeHTML(str);
  }

  return str;
}
